import type { CompassUnifiedConfigurationOnAzure } from '../../../generated-client/models';
import { getAlertOptionLabel } from './alertOptionsLabels';

/**
 * Determines the display value for voltage sensitivity based on all voltage settings
 * @param config - The unified configuration
 * @returns "User Defined", "Disabled", or "Custom"
 */
export const getVoltageSensitivityDisplay = (
  config: CompassUnifiedConfigurationOnAzure,
): string => {
  // Combine all voltage settings including smart adaptive flags
  const allSettings = [
    ...config.lv_allowed_settings,
    config.lv_smart_adaptive_allowed,
    ...config.mv_allowed_settings,
    config.mv_smart_adaptive_allowed,
    ...config.hv_allowed_settings,
    config.hv_smart_adaptive_allowed,
  ];

  if (allSettings.every((v) => v === true)) return 'User Defined';
  if (allSettings.every((v) => v === false)) return 'Disabled';
  return 'Custom';
};

/**
 * Determines the display value for current sensitivity based on all current settings
 * @param config - The unified configuration
 * @returns "User Defined", "Disabled", or "Custom"
 */
export const getCurrentSensitivityDisplay = (
  config: CompassUnifiedConfigurationOnAzure,
): string => {
  // Combine all current settings including smart adaptive flag
  const allSettings = [
    ...config.current_allowed_settings,
    config.current_smart_adaptive_allowed,
  ];

  if (allSettings.every((v) => v === true)) return 'User Defined';
  if (allSettings.every((v) => v === false)) return 'Disabled';
  return 'Custom';
};

/**
 * Gets the StringKey for an AlertOptions value.
 * Use with t() function for translation.
 *
 * @param alertValue - The alert enum value from API
 * @returns StringKey for translation (e.g., StringKeys.USER_DEFINED)
 *
 * @example
 * const labelKey = getAlertOptionStringKey(config.impact_detection);
 * const translatedLabel = t(labelKey);
 */
export const getAlertOptionStringKey = getAlertOptionLabel;
